import { Stack, styled } from "@mui/material";

const StyledListOuter = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  minHeight: "100%",
  borderRadius: theme.shape.borderRadius,
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
  // paddingTop: theme.spacing(4),
  // paddingBottom: theme.spacing(4),
  // gap: theme.spacing(2),
  margin: "auto",
  overflow: "hidden",
  maxHeight: `calc(100% - 0px)`,
  flexGrow: 1,
  // boxShadow:
  //   "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  // ...theme.applyStyles("dark", {
  //   boxShadow:
  //     "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
  // }),
}));

export default StyledListOuter;
